import React from 'react';
import myImg from '../../images/279926739-1322176401592416-7681994299822122901-n-removebg.jpg';

const MyPortfolio = () => {
    return (
        <div className='mx-20 my-20'>
            <div class="avatar mb-20 flex justify-center items-center">
                <div class="w-64 rounded-full">
                    <img src={myImg} alt="" />
                </div>
            </div>
            <p>
                Web Developer <br />
                Skills: <br />
                - Languages: HTML5, CSS3, JavaScript <br />
                - Technologies: Rest APIs, JSON <br />
                - Frameworks: Bootstrap5, Express, React, Node.js <br />
                - Database: Mongo DB <br />
                - IDE/Tools: Visual Studio <br />
                - Version Control: Git <br />
                <br /> <br />
                I have been interested in tech and coding from an early age. My first exposure to programming logic came from sandbox video games like Minecraft and LittleBigPlanet when I was 10. I made modular analog clocks, complex vault doors, top-down arcade games, and more! <br /><br />

                Now I'm a  Frontend Developer who codes with React and RESTful APIs, hoping it helps and improves people's lives. The positive effects of the applications and websites I build are what motivate me to keep learning, developing, and iterating. <br /><br />

                I like to connect with people and share ideas, so feel free to reach out at
                md.arifulislam11819@gmail.com <br /><br />

                My name is Ariful Islam and I’m a Front End Developer based in Dinajpur, Bangladesh. I was born and raised in Pabna, Bangladesh. Yeah… I’m currently working at scientific games for now but my contract will be over in 2 weeks. I'm looking forward to working with a team that will accept my talents and my amazing personality. I’m very passionate about creating amazing experiences and making my clients say “ WOAH!!! “ with the project they receive back from me. As an experienced Frontend, I can bring many skills and a lot of experience in styling projects. I bring direct experience and expertise in languages like JavaScript CSS3, HTML5 and React.Js, and also more. I can also offer team leadership experience. I excel under pressure and have strong leadership skills like coaching and support. <br /><br />

                • Portfolio: https://sweet-biscochitos-218a14.netlify.app/ <br /><br />


                Software Engineer dedicated to improving skills through hands-on learning and development work. Proficient in mobile and web development environments. Skilled in using JavaScript, REACT, Node.js, HTML5, CSS, and other programming languages to produce clean code. Well-organized and collaborative team player with strong communication and analytical abilities. <br /><br />

                I am a front-end web developer with experience in ReactJs, Javascript, HTML, and CSS. I created projects using Visual Studio Code and GitHub. <br /><br />

                View my GitHub: https://github.com/Arif11819 <br /><br />

                Frameworks: <br />
                Express.Js <br /><br />

                Languages and Libraries: <br />
                JavaScript, HTML5, CSS3, React.Js, Mongoose (MongoDB) <br /><br />

                Database Software: <br />
                MongoDB <br /><br />

                Tools: <br />
                GitHub, Netlify, Heroku, Visual Studio Code <br /><br />

                Experienced Web Developer is skilled in React.js, Cascading Style Sheets (CSS), Node.js, JavaScript, and jQuery.
            </p>
        </div>
    );
};

export default MyPortfolio;